module.exports = __webpack_public_path__ + "img/video-camera.3b9e529f.svg";